import FieldStatus from "../../../../fields3/generic/status/status"
import FieldConfig from "../../../../fields3/proto/field-config"
import FieldTaskSystemStatus_ConditionForm from "./render/condition"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types"
import FieldTaskSystemStatus_QuickFilterView from "./render/quick-filter-view"
import FieldTaskSystemStatus_ViewSmall from "./render/view-small"
import FieldTaskSystemStatus_ViewGroup from "./render/group/group"
import {SystemStatus} from "../../../../gd/const/system-status"
import GroupBy from "../../../../gd/manager/group-by/group-by-model"
import {FieldGroupAllPossibleValues_Params} from "../../../proto/types"

/** !!!! CREATED FOR conditionForm render, other views are not tested !!!! **/

export default class FieldTaskSystemStatus extends FieldStatus {

    constructor(config:FieldConfig) {
        super(config)


        this.conditionTypes                 = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel                      = "Task System Status"
        this.filterType                     = null

        this.noValueOption                  = false // system status always set

        this.options                        = gd.const.systemStatus.options

        this.canManuallySetValue            = false
        this.isGroupByAllOptionsAvailable   = true

        _.assign(this.components, {
            PopoverMenuMore     : null,
        })

        // _.assign(this.renderComponents, {
        //     conditionForm       : FieldTaskSystemStatus_ConditionForm
        // })

        this.renderComponents.viewSmall         = FieldTaskSystemStatus_ViewSmall

        this.renderComponents.conditionForm     = FieldTaskSystemStatus_ConditionForm
        this.renderComponents.quickFilterView   = FieldTaskSystemStatus_QuickFilterView

        this.renderComponents.viewGroup         = FieldTaskSystemStatus_ViewGroup
    }

    groupSortValue(value: any, groupBy?:GroupBy) {
        return _.get(this._getOption(value), 'value', undefined)
    }

    /** GROUP BY **/
    groupAllPossibleValues(params: FieldGroupAllPossibleValues_Params): any[] {
        return _.orderBy([
                SystemStatus.NOT_STARTED,
                SystemStatus.IN_PROGRESS,
                SystemStatus.IN_REVIEW,
                SystemStatus.ON_HOLD,
                SystemStatus.COMPLETED,
                SystemStatus.CANCELLED
            ],
            [
                // null/undefined values are sorted first/last depending on direction
                (value: any) => {
                    return _.isNil(value) ? 0 : 1
                },
                // actual group value using field sort function
                (value: any) => {
                    return this.groupSortValue(value, params.groupBy)
                },
            ],
            [
                params.groupBy.sortDirection,
                params.groupBy.sortDirection
            ],
        )
    }
}
